import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'address_line_1'

export const dataPointDefinition = {
  retracedId: 'address_line_1',
  name: 'Address Line 1',
  description: 'Refers to the street address on the business license(s) associated with the facility name.',
  meta: {
    slcpMeta: {
      key: 'fp-bas-1',
      number: 'FP-BAS-1',
      dataType: 'string',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'LONG_TEXT',
  type: 'GLOBAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-bas-1',
      version: '1.7.0',
      provider: 'slcp',
    },
  ],
  sortingId: 70,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
